export default __webpack_public_path__ + "static/media/featRaceBgMb.0617d759.png";